import styled from '@emotion/styled'
import { PlayBtn } from '../../../icons/Icons'

export const VideoIsPlayingOverlay: React.FC = () => {
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgb(0 0 0 / 60%)',
                zIndex: 6,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pointerEvents: 'none',
                borderRadius: 'inherit',
                color: 'white',
            }}
        >
            <p>Video is playing</p>
        </div>
    )
}

const PlayButtonContainer = styled.div({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    zIndex: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
})

const PlayCircle = styled.div({
    width: 50,
    height: 50,
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
})

export const PlayButtonOverlay: React.FC = () => {
    return (
        <PlayButtonContainer>
            <PlayCircle>
                <PlayBtn />
            </PlayCircle>
        </PlayButtonContainer>
    )
}
